module.exports = __webpack_public_path__ + "static/media/sbay-app-logo.48183c20.png";